import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import "./OriginCertificateUpload.scss"
import messages from "../../assets/i18n";
import { HeaderActions, FooterActions, ToastMessage, ButtonStandard, LoadingSpinner } from "../../components";
import UploadFiles from "../../components/UploadFiles/UploadFiles";
import { Container, Row, Col, Form } from "react-bootstrap";

function OriginCertificateUpload(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);

    const fileDetails = useSelector(state => state.originCertificate.fileDetails);
    const existingFile = useSelector(state => state.originCertificate.file);
    const isLoading = useSelector(state => state.originCertificate.isLoading);
    const toast = useSelector(state => state.originCertificate.toast);

    const ACCEPT_TYPE = 'application/pdf';

    const [isEdit, setIsEdit] = useState(false);

    const [showToast,    setShowToast]    = useState(false);
    const [messageError, setMessageError] = useState('');
    const [messageType,  setMessageType]  = useState('toast-error');

    const [renderCount, setRenderCount] = useState(0);

    const [localFileValue, setLocalFileValue] = useState({
        orderId: '',
        code: ''
    });

    const [uploadedFile, setUploadedFile] = useState(undefined);

    const pageMessages = messages[lang].originCertificateUploadPage;

    useEffect(() => {
        if (props.history.location.id) {
            setIsEdit(true);

            dispatch({
                type: 'GET_ORIGIN_CERTIFICATE_FILE',
                payload: {
                    id: props.history.location.id,
                }
            })
        } else {
            setIsEdit(false);

            dispatch({
                type: 'SET_NEW_FILE_DETAILS',
                payload: {
                    orderId: '',
                    code: ''
                }
            })

            dispatch({
                type: 'SET_ORIGIN_CERTIFICATE_FILE',
                payload: undefined
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
        if (existingFile) {
            setUploadedFile(convertBase64ToFile(existingFile))            
        } else {
            setUploadedFile(undefined)  
        }
        // ?  :
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [existingFile]);

    useEffect(() => {
        setLocalFileValue({...fileDetails})
        // ?  :
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [fileDetails]);

    useEffect(() => {
        if (renderCount >= 1) {
            setShowToast(toast.showToast)
            setMessageError(toast.message)
            setMessageType(toast.messageType)
        } else {
            let count = parseInt(renderCount) + 1
            setRenderCount(count)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [toast]);

    const validateAndStoreLocalFile = file => {
        setUploadedFile(undefined);

        if (!file || file.length === 0) {
            setShowToast(true);
            setMessageType('toast-error')
            setMessageError(messages[lang].mustBePDF);
        } else if (file.length > 1) {
            setShowToast(true);
            setMessageError('error');
        } else if (file[0].type !== 'application/pdf') {
            setShowToast(true);
            setMessageError(messages[lang].mustBePDF);
        } else {
            setUploadedFile(file[0]);
        }
    
    };

    const pageBack = () => {
		history.push('/origin-certificate');
	};

    const updateFields = (fields) => {
        dispatch({
            type: 'SET_NEW_FILE_DETAILS',
            payload: fields
        })
    };

    const removeFile = () => {
        setUploadedFile(undefined);
    };

    const downloadFile = () => {
        let reader = new FileReader();
        let file = uploadedFile
		reader.readAsBinaryString(file);
		reader.onload = () => {
			let base64 = new FileReader();
			base64.readAsDataURL(file);
			base64.onload = () => {
				const downloadLink = document.createElement("a");
				downloadLink.href = base64.result;
				downloadLink.download = file.name;
				downloadLink.click();
			}
		};
	};

	const convertBase64ToFile = (base64) => {
        if (base64) {
            const byteString = window.atob(base64);
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i += 1) {
                ia[i] = byteString.charCodeAt(i);
            }

            const filename = pageMessages.fileName + (props.history.location.order ? '_' + props.history.location.order : '') + '.pdf'
            return new File([ab], filename);
        }
    };

    const saveButton = disabled => () =>
        <ButtonStandard
            id="origin_certificate_save_button"
            text={messages[lang].save}
            textClass="text-2"
            isLoading={false}
            disabled={!uploadedFile || !fileDetails.code || !fileDetails.orderId || isLoading}            
            className="btn btn-primary btn-save btn-light"
            onClick={() =>  dispatch({
                type: 'UPLOAD_ORIGIN_CERTIFICATE',
                payload: {
                    fileDetails: fileDetails,
                    file: uploadedFile,
                    isEdit: isEdit
                }
            })}
    />;

	return (
		<div className="origin-certificate-upload-page">
           <ToastMessage 
            show={showToast} 
            setShow={setShowToast} 
            message={messageError} 
            toastClass={messageType} />
        
            <HeaderActions pageBack={pageBack} titlePage={pageMessages.title} />

            {
                isLoading
                ?
                    <div className="loader">
                        <LoadingSpinner />    
                    </div> 
                :
                    null
            }

            <Container className="pt-3 justify-content-start">
                <Row>
                    <Form.Group as={Col}>
                        <Form.Label className="text-2">{pageMessages.order}</Form.Label>
                        <Form.Control
                            className="text-2 border-radius-full"
                            type="text"
                            placeholder={pageMessages.order}
                            defaultValue={localFileValue.orderId || ''}
                            disabled={isEdit}
                            onChange={event => updateFields(
                                { ...fileDetails, orderId: event.target.value},
                            )}
                            />
                    </Form.Group>

                    <Form.Group as={Col}>
                        <Form.Label className="text-2">{pageMessages.code}</Form.Label>
                        <Form.Control
                            className="text-2 border-radius-full"
                            type="text"
                            placeholder={pageMessages.code}
                            defaultValue={localFileValue.code || ''}
                            disabled={false}
                            onChange={event => updateFields(
                                { ...fileDetails, code: event.target.value},
                            )}
                            />
                    </Form.Group>
                </Row>
            </Container>

            <UploadFiles
                accept={ACCEPT_TYPE}
                validateAndStoreLocalFile={validateAndStoreLocalFile}
                uploadedFile={uploadedFile}
                downloadFile={downloadFile}
                removeFile={removeFile}
            />

            <FooterActions
				ButtonGroupRight={saveButton(false)}/>
		</div>
	)
}

export default withRouter(OriginCertificateUpload);